import { Box, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { motion } from 'framer-motion';

const ORANGE = '#FF6B00';
const DARK = '#1A1A1A';
const MUTED = '#555';
const SOFT = '#F8F9FA';

export function RackingSystemDetail({ product }) {
  const features = Array.isArray(product?.features) ? product.features : [];

  return (
    <Box sx={{ py: { xs: 6, md: 8 }, bgcolor: '#fff', borderBottom: '1px solid #ededed' }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Box component={motion.div} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}>
          <Typography sx={{ color: ORANGE, fontWeight: 900, letterSpacing: 3, mb: 1, textTransform: 'uppercase', fontSize: '0.78rem' }}>
            Racking System {String(product.number).padStart(2, '0')}
          </Typography>
          <Typography sx={{ fontWeight: 900, color: DARK, fontSize: { xs: '1.75rem', md: '2.5rem' }, lineHeight: 1.15, mb: 1 }}>
            {product.name}
          </Typography>
          <Typography sx={{ color: ORANGE, fontWeight: 600, mb: 3, fontSize: { xs: '1rem', md: '1.1rem' } }}>
            {product.tagline}
          </Typography>

          <Paper elevation={0} sx={{ border: '1px solid #e4e4e4', borderRadius: 0, p: { xs: 2.5, md: 3.5 } }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    border: '1px solid #e4e4e4',
                    bgcolor: SOFT,
                    height: { xs: 260, md: 320 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={product.image}
                    alt={product.name}
                    sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={7}>
                <Typography sx={{ color: MUTED, lineHeight: 1.75, fontSize: { xs: '1rem', md: '1.05rem' }, mb: 2.5 }}>
                  {product.description}
                </Typography>
                <Stack spacing={1}>
                  {features.map((feature) => (
                    <Stack key={feature} direction="row" spacing={1.25} alignItems="flex-start">
                      <CheckCircleOutlineIcon sx={{ color: ORANGE, fontSize: 18, mt: 0.2, flexShrink: 0 }} />
                      <Typography sx={{ color: DARK, lineHeight: 1.55, fontSize: '0.95rem', fontWeight: 500 }}>
                        {feature}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Grid>
            </Grid>

            {product.secondaryImage ? (
              <Box sx={{ mt: 3, pt: 3, borderTop: '1px solid #ececec' }}>
                <Typography sx={{ color: DARK, fontWeight: 800, mb: 1.5, fontSize: '1rem' }}>{product.secondaryLabel}</Typography>
                <Box
                  sx={{
                    border: '1px solid #e4e4e4',
                    bgcolor: '#fff',
                    p: 2,
                    height: { xs: 180, md: 220 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src={product.secondaryImage}
                    alt={product.secondaryLabel}
                    sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </Box>
              </Box>
            ) : null}
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

export default RackingSystemDetail;
